import { ThemeColors, ThemeColorsValues } from '../../theme';

export const getPaletteBasename = (color: ThemeColorsValues): ThemeColors => {
  if (!color.includes('.')) {
    return color as ThemeColors;
  }

  return color.split('.')[0] as ThemeColors;
};
